// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___Flm1t","bodyMargin":"bodyMargin___HRDYr","links":"links___cVPid","submit":"submit___BR9aO","modalTerms":"modalTerms___qPS6N"};